/** @module Apparel/CarryOverSKUForm */
define([
    "dojo/_base/declare",
    "./CreateSKUForm"
], function(declare,CreateSKUForm) {

    return declare(CreateSKUForm, {
        /**
         * C8-8642 : Hide the unnecessary fields "RealizedColor" and "RealizedSize"
         */
        _resolveView: function() {
            this.inherited(arguments);

            this.defView.removeField("RealizedColor");
            this.defView.removeField("RealizedSize");
        }
    });
});